<div class="gradient-component">
    <div>
        <button mat-flat-button [matMenuTriggerFor]="gradientMenu" class="gradient-button">
            <div class="gradient-preview" [style.background]="getGradientStyle()" mat-button></div>

            <div class="edit row-centered">
                <mat-icon>edit</mat-icon>
            </div>
        </button>
        <mat-menu class="pickers" #gradientMenu="matMenu">
            <div (click)="$event.stopPropagation()">
                <div class="color-picker-wrapper" *ngFor="let color of colors; let i = index">
                    <div>
                        <app-color-pallet
                            [color]="color.color"
                            [key]="i"
                            [displayBrandColors]="true"
                            (colorChanged)="onColorChange($event)"></app-color-pallet>
                    </div>
                    <input
                        type="number"
                        id="numberInput"
                        [(ngModel)]="color.position"
                        (change)="validatePosition(color)"
                        min="0"
                        max="100" />
                    <button
                        mat-icon-button
                        color="primary"
                        (click)="$event.stopPropagation(); removeColor(i)"
                        [disabled]="colors?.length <= 1"
                        [matTooltip]="'Remove color'">
                        <mat-icon>remove</mat-icon>
                    </button>
                </div>
                <button mat-icon-button color="primary" (click)="addColor()" [matTooltip]="'Add another color'">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </mat-menu>
    </div>
</div>
